import update from 'immutability-helper';
import { handleActions } from 'redux-actions';

import {
  SET_CURRENT_STEP,
  SET_PREVIOUS_STEP,
  SET_IS_FROM_EXTERNAL_SOURCE,
} from '../type';
import { initialState } from './initialize';

const stepReducer = handleActions(
  new Map([
    [
      SET_CURRENT_STEP,
      (state, action) => {
        return update(state, {
          currentStep: {
            $set: action.payload,
          },
        });
      },
    ],
    [
      SET_PREVIOUS_STEP,
      (state, action) => {
        return update(state, {
          previousStep: {
            $set: action.payload,
          },
        });
      },
    ],
    [
      SET_IS_FROM_EXTERNAL_SOURCE,
      (state, action) => {
        return update(state, {
          isFromExternalSource: {
            $set: action.payload,
          },
        });
      },
    ],
  ]),
  initialState,
);

export default stepReducer;
